import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.debugMode)?_c(VSheet,{staticClass:"debug-mode-indicator"},[_c(VIcon,[_vm._v("mdi-bug")]),_c('p',{staticClass:"subtitle-2"},[_vm._v("Debug Mode Enabled")]),_c('qvoButton',{attrs:{"text":""},on:{"click":_vm.disableDebugMode}},[_vm._v("Disable")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }